import type { Call } from '@twilio/voice-sdk';

export type TwilioStatus =
  | 'uninitialized'
  | 'registering'
  | 'ready'
  | 'busy'
  | 'offline'
  | 'error';

export interface UseTwilioVoiceReturn {
  status: TwilioStatus;
  error: string | null;
  startCall: (toNumber: string, params?: Record<string, string | number | boolean>) => Promise<void>;
  endCall: () => void;
  sendDigits: (digits: string) => void;
  currentCall: () => Call | null;
}

export interface TwilioStore {
  status: TwilioStatus;
  hasActiveCall: boolean;
  activeCall: Call | null;
  isMuted: boolean;

  callSid: string | null;
  conferenceName: string | null;

  setStatus: (status: TwilioStatus) => void;
  setActiveCall: (active: boolean) => void;
  setCall: (call: Call | null) => void;
  setIsMuted: (v: boolean) => void;

  setCallSid: (sid: string | null) => void;
  setConferenceName: (name: string | null) => void;

  hangupCall: () => void;
  muteCall: () => void;
  unmuteCall: () => void;
}

export interface TwilioVoiceTokenResponse {
  token: string;
  identity: string;
}
